import {useEffect, useState} from "react";
import {Bell, BellOff} from "lucide-react";
import {disablePush, enablePush, pushState} from "@/lib/push";

const LABEL = {on: "Notifikasi aktif", off: "Aktifkan notifikasi booking", denied: "Notifikasi diblokir browser", unsupported: "Browser tidak mendukung notifikasi", busy: "Memproses…"};

export const PushToggle = ({save, remove, hint}) => {
  const [state, setState] = useState("busy");
  useEffect(() => { pushState().then(setState).catch(() => setState("unsupported")); }, []);
  const toggle = async () => {
    const prev = state;
    setState("busy");
    try { setState(prev === "on" ? await disablePush(remove) : await enablePush(save)); }
    catch (e) { alert("Notifikasi belum bisa diaktifkan. Coba lagi."); setState(prev); }
  };
  const off = state !== "on";
  return <div className="push-toggle" data-testid="push-toggle">
    <button type="button" className={`push-btn ${state}`} data-testid="push-toggle-button" disabled={["busy", "denied", "unsupported"].includes(state)} onClick={toggle}>
      {off ? <BellOff size={16}/> : <Bell size={16}/>}{LABEL[state]}
    </button>
    {state === "on" && <button type="button" className="link-btn" data-testid="push-disable-button" onClick={toggle}>Matikan</button>}
    {hint && <small>{state === "denied" ? "Izinkan notifikasi untuk situs ini di pengaturan browser." : hint}</small>}
  </div>;
};
